var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHexagonBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 1332,
    viewBox: "0 0 1536 1332",
    width: 1536,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.81403 650.73 183.20797-317.32.051.03 183.153-317.233 8.885-15.38803h17.475 366.414 366.41 17.48l8.88 15.38803 183.16 317.233.05-.03 183.21 317.32 8.81 15.27-8.81 15.27-183.21 317.32-.05-.03-183.16 317.23-8.88 15.39h-17.48-366.41-366.414-17.475l-8.885-15.39-183.153-317.23-.051.03-183.20797-317.32-8.81500656-15.27z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonBlack);
export default __webpack_public_path__ + "static/media/hexagon-black.ccdb2252211ab855e4f4e076ac7428b3.svg";
export { ForwardRef as ReactComponent };